import React from "react";

export default function WhiteButton(props) {
  const submitChange = () => {
    if (props.submitChange) props.submitChange();
  };
  return (
    <>
      <button
        type="button"
        className="btn orangeButton orangeButtonText paddingbutton navButtonText d-flex align-items-center"
        onClick={submitChange}
      >
        {props.buttonText}
      </button>
    </>
  );
}
